import { sendMessage } from './errorHandlingActions';
import { setProgress } from './progressActions';

import {
	AddTemplateAction,
	ADD_TEMPLATE,
	GetTemplatesAction,
	GetTemplatesByDeviceTypeAction,
	GET_TEMPLATES_LIST,
	GET_TEMPLATES_LIST_BY_DEVICE_TYPE,
	ResetTemplateForm,
	ResetTemplatesByDeviceType,
	RESET_TEMPLATE_FORM,
	RESET_TEPLATES_BY_DEVICE_TYPE,
} from 'store/types/template';
import {
	deleteTemplate,
	getTemplatesList,
	getTemplatesListByDeviceTypeId,
} from 'services/template.service';
import { Template } from '@horasys/bellplus/common/types';

export const resetTemplatesByDeviceType = (): ResetTemplatesByDeviceType => {
	return {
		type: RESET_TEPLATES_BY_DEVICE_TYPE,
	};
};

export const resetTemplateForm = (): ResetTemplateForm => {
	return {
		type: RESET_TEMPLATE_FORM,
	};
};

export const getAllTemplates = (payload: Array<Template>): GetTemplatesAction => {
	return {
		type: GET_TEMPLATES_LIST,
		payload: payload,
	};
};

export const addTemplate = (payload: Template): AddTemplateAction => {
	return {
		type: ADD_TEMPLATE,
		payload: payload,
	};
};

export const getAllTemplatesByDeviceType = (
	payload: Array<Template>,
): GetTemplatesByDeviceTypeAction => {
	return {
		type: GET_TEMPLATES_LIST_BY_DEVICE_TYPE,
		payload: payload,
	};
};

export const getAllTemplateDetails = () => async (dispatch: any) => {
	try {
		dispatch(setProgress(true));
		const templates = await getTemplatesList();
		dispatch(getAllTemplates(templates));
		dispatch(setProgress(false));
	} catch (error:any) {
		dispatch(sendMessage(error, 'error'));
		dispatch(setProgress(false));
	}
};

export const getAllTemplateDetailsByDeviceType = (deviceTypeId: number):any => async (
	dispatch: any,
) => {
	try {
		dispatch(setProgress(true));
		const templates = await getTemplatesListByDeviceTypeId(deviceTypeId);
		dispatch(getAllTemplatesByDeviceType(templates));
		dispatch(setProgress(false));
	} catch (error:any) {
		dispatch(sendMessage(error, 'error'));
		dispatch(setProgress(false));
	}
};

export const deleteTemplateThunkById = (
	templateId: number,
	setTemplatesList: any,
):any => async (dispatch: any) => {
	try {
		dispatch(setProgress(true));
		await deleteTemplate(templateId);
		dispatch(setProgress(false));
		dispatch(sendMessage('DELETED SUCCESSFULLY', 'success'));
		const templates = await getTemplatesList();
		setTemplatesList(templates);
		//dispatch(getAllCampaignDetails());
	} catch (error:any) {
		dispatch(sendMessage(error, 'error'));
		dispatch(setProgress(false));
	}
};
